'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'narwhal';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f6fe';
var svgPathData = 'M640 336c0-49-20.2-93.2-52.7-125.2L640 0 511.7 166.8c-15.5-4.4-31.8-6.8-48.6-6.8-50.9 0-100.7 17.5-140.2 49.6l-194.9 158.4 0-112 64-32 0-128-96 48-96-48 0 128 64 32 0 96c0 88.4 71.6 160 160 160l240 0c97.2 0 176-78.8 176-176zM496 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faNarwhal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;